import { AppToaster } from "@components/AppToaster";
import { OrgData } from "@types";

import { fetchRulesYamlFromPolicy } from "../api";
import { PolicyAllRulesYaml, RuleFromYaml } from "../types";

export const onLoadPolicy = (
  org: OrgData,
  policySlug: string,
  setIsLoading: (isLoading: boolean) => void,
  setAllRules: (rules: RuleFromYaml[]) => void
) => {
  if (policySlug === undefined) {
    return;
  }
  setIsLoading(true);
  fetchRulesYamlFromPolicy(org.id, policySlug)
    .then((resp: PolicyAllRulesYaml) => {
      setAllRules(resp.rules);
    })
    .catch((err) => {
      let msg;
      if (err.body["error"] === "not found") {
        msg = `ERROR: Could not find policy "${policySlug}"`;
      } else {
        msg = "One or more rules or snippets could not be found";
      }
      AppToaster.show({
        message: msg,
        intent: "danger",
      });
      setAllRules([]);
    })
    .finally(() => setIsLoading(false));
};
